<template>
    <div class="tenjityModule-section-header" @click="handleClickExpend">
        <div ref="reset" @click.stop="handleClickReset">
            <Icon class="tenjityModule-section-icon" icon="fluent:arrow-clockwise-48-filled" />
        </div>
        <div class="tenjityModule-section-title" role="button">{{ title }}</div>
        <div ref="expend">
            <Icon
                class="tenjityModule-section-icon tenjityModule-section-icon-right"
                :class="isSectionActive && 'tenjityModule-section-icon-right-active'"
                icon="fluent:chevron-up-12-filled"
            />
        </div>
    </div>
</template>

<script>
import { Icon } from "@iconify/vue";
export default {
    name: "AccessibilitySectionHeader",
    props: {
        title: String,
        isSectionActive: Boolean,
    },
    components: {
        Icon,
    },
    methods: {
        handleClickReset() {
            this.$emit("handleClickReset");
            this.$refs.reset.classList.add("tenjityModule-section-icon-anim");
            setTimeout(() => {
                this.$refs.reset.classList.remove("tenjityModule-section-icon-anim");
            }, 300);
        },
        handleClickExpend() {
            this.$emit("handleClickExpand");
        },
    },
};
</script>
